import React from 'react';
import DataTable from '../../smart-kit/data-table/DataTable';
import { SimpleCard } from 'app/components';
import { apiPaths } from 'app/services/api';
import { translate } from 'translate';

const Banners = () => {
  const columns = [
    {
      name: 'Title',
      key: 'title',
    },
    {
      name: 'Active',
      key: 'active',
      render: (row) =>
        row.active ? (
          <span className="text-green-500">{translate('Active')} </span>
        ) : (
          <span className="text-red-500">{translate('Inactive')} </span>
        ),
    },
    {
      name: 'Create Date',
      key: 'created_at',
      type: 'date',
      sort: true,
    },
  ];

  const filtersOn = [
    // { name: 'Mobile', key: 'mobile_number' },
    { name: 'Title', key: 'title' },
  ];

  return (
    <div className="m-sm-30">
      <div className="mb-sm-30"></div>
      <div className="py-3" />
      <SimpleCard>
        <DataTable
          title="Banners"
          path="banners"
          apipath={apiPaths.BANNERS}
          columns={columns}
          filtersOn={filtersOn}
          hideActions={['delete', 'view']}
          // showExport
        />
      </SimpleCard>
    </div>
  );
};

export default Banners;
